import { useEffect, useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Network from "../../utils/Network";
import { Urls } from "../../utils/Constants";

export default function Fastag() {
    const [errors, setErrors] = useState({});
    const [billers, setBillers] = useState([]);
    const [caNumber, setCaNumber] = useState("");
    const [selectedBiller, setSelectedBiller] = useState("");
    const [name, setName] = useState("");
    const [ad1, setAd1] = useState("");
    const [ad2, setAd2] = useState("");
    const [accountHolderName, setAccountHolderName] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [billData, setBillData] = useState("");
    const [amount, setAmount] = useState("");

    useEffect(()=>{
        fetchBiller();
    },[])

    const fetchBiller = async () => {        
        let formData = new FormData();
        const localStorageDataStr = localStorage.getItem('token');
        const item = JSON.parse(localStorageDataStr);
        formData.append("api_token", item.token);
        try {
            const response = await Network.post(Urls.baseUrlPostLogin + '/fastag/biller', formData);
            if(response?.data){
                setBillers(response.data);
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const fetchBill = async () => {
        const newErrors = errorHandling('fetchBill');
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            let formData = new FormData();
            const localStorageDataStr = localStorage.getItem('token');
            const item = JSON.parse(localStorageDataStr);
            formData.append("api_token", item.token);
            formData.append("operator_id", selectedBiller);
            // formData.append("name", localStorage.getItem('token'));
            // formData.append("canumber", localStorage.getItem('token'));
            try {
                const response = await Network.post(Urls.baseUrlPostLogin + '/lic-bill-fetch', formData);
                console.log(response);
                // if(response?.data){

                // }else{
                // const apiErrors = {apiError : response.data.message};
                // setErrors(apiErrors);
                // }
            } catch (err) {
                console.log('error', err);
            }
        }
    }

    const errorHandling = (type) => {
        const errors = {};
        if (type === 'fetchBill') {
            if(!caNumber.trim()){
                errors.caNumber = 'CA number is required';
            }else if(selectedBiller === ''){
                errors.selectedBiller = 'Operator is required';
            }
        }
        return errors;
    };

    return (
        <>
            <Header />
            <div className="adminuiux-wrap">
                <Sidebar />
                <main
                    className="adminuiux-content has-sidebar"
                >
                    {/*mt-4*/}
                    <div className="container " id="main-content">
                        <div className="row align-items-center">
                        </div>
                        {/* dashboard inner */}
                        <div className="midde_cont">
                            <div className="container-fluid" data-select2-id="select2-data-43-olwc">
                                <div className="row column_title">
                                    <div className="col-md-12">
                                        <div className="page_title d-sm-flex">
                                            <h2>Fastag</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row match-height" data-select2-id="select2-data-42-ddgt">
                                    <div className="col-md-4 col-12" data-select2-id="select2-data-41-p3sb">
                                        <div className="card" data-select2-id="select2-data-40-swoz">
                                            <div className="card-header"></div>
                                            <div className="card-content" data-select2-id="select2-data-39-xbtz">
                                                <div className="card-body" data-select2-id="select2-data-38-jiu3">                                                    
                                                    <div className="form-body" data-select2-id="select2-data-37-8po5">
                                                        <div className="col-12" data-select2-id="select2-data-36-sbud">
                                                            <div
                                                                className="form-group"
                                                                data-select2-id="select2-data-35-457j"
                                                            >
                                                                <label htmlFor="first-name-vertical">Operator</label>
                                                                <select
                                                                    className="form-control js-example-basic-single select2-hidden-accessible"
                                                                    id="operator_id"
                                                                    tabIndex={-1}
                                                                    aria-hidden="true"
                                                                    data-select2-id="select2-data-operator_id"
                                                                    onChange={(e) => { setSelectedBiller(e.target.value) }}
                                                                >
                                                                    {billers.map((item) => (
                                                                        <option value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                                {errors.selectedBiller && (
                                                                    <span className="error-message">
                                                                        {errors.selectedBiller}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <label htmlFor="contact-info-vertical">CA Number</label>
                                                                <input
                                                                    type="text"
                                                                    id="canumber"
                                                                    className="form-control"
                                                                    maxLength={10}
                                                                    placeholder="CA Number"
                                                                    autoComplete="off"
                                                                    value={caNumber}
                                                                    onChange={(e) => { setCaNumber(e.target.value) }}
                                                                />
                                                            </div>
                                                            {errors.caNumber && (
                                                                <span className="error-message">
                                                                    {errors.caNumber}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="col-12">
                                                            <button
                                                                className="btn btn-sm btn-primary float-right tx-12"
                                                                onClick={fetchBill}
                                                            >
                                                                Fetch Details
                                                            </button>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* Modal */}
                    </div>
                </main>
            </div>
        </>
    );
}